<template>
  <v-container
    fluid
    style="height: 100%;"
    class="pl-0 pr-2 py-0 m-0 box"
    align-stretch
  >
    <v-layout row wrap ma-0 py-4 justify-start>
      <v-flex xs12>
        <p class="font-weight-medium my-0 ml-4 pl-4">ลักษณะรถบรรทุกที่เกิดเหตุ</p>
        <v-card
          class="d-flex justify-start ma-0 my-2 px-2"
          :class="[{ row: $vuetify.breakpoint.smAndDown }, { 'pl-4': $vuetify.breakpoint.mdAndUp }]"
          flat
        >
          <v-flex :class="[$vuetify.breakpoint.mdAndUp ? 'col-3' : 'col-12']">
            <v-card class="rectangle2 ml-0">
              <highcharts class="charts-pie" :options="chartPieOptions" ref="chart"></highcharts>
            </v-card>
          </v-flex>
          <!-- <v-card
            class="rectangle1 col-3 px-0 pt-0"
            v-for="(item, i) in trailerkind"
            :key="i"
            :class="[{ row: $vuetify.breakpoint.smAndDown }, { 'pl-4': $vuetify.breakpoint.mdAndUp }]"
          >
            <div>
              <p class="subtitle-2 text-center mt-3 mb-2 title-cause">{{ item.name }}</p>
            </div>
            <div class="pa-0 px-2">
              <v-layout ma-0>
                <v-flex xs5>
                  <v-img class="sub-menu" height="32" width="32" :src="getCauseImage(item.id)"></v-img>
                </v-flex>
                <v-flex xs7 text-center>
                  <p class="font-weight-medium my-0 title number">{{ item.accident_count | numFormat }}</p>
                  <p class="caption mb-0">{{ item.percentage }}</p>
                </v-flex>
              </v-layout>
            </div>
            <v-row class="ma-0 pt-6 text-center cause-casualty">
              <v-col cols="6" class="pa-0">
                <div class="text-center">
                  <v-img contain height="28" :src="require('@/assets/icons/death.svg')" class="ma-0 mt-2"></v-img>
                  <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i>
                </div>
                <p class="font-weight-medium subtitle-1 my-0">{{ item.dead | numFormat }}</p>
                <p class="subtitle-2 my-0">คน</p>
              </v-col>
              <v-col cols="6" class="pa-0">
                <div class="text-center">
                  <v-img contain height="28" :src="require('@/assets/icons/user-injured-solid.svg')" class="ma-0 mt-2"></v-img>
                </div>
                <p class="font-weight-medium subtitle-1 my-0">{{ item.injury | numFormat }}</p>
                <p class="subtitle-2 my-0">คน</p>
              </v-col>
            </v-row>
          </v-card> -->
          <v-flex
            class="py-3"
            v-for="(item, i) in trailerkind.filter(a => a.accident_count > 0)"
            :key="i"
            :v-show="item.accident_count > 0"
            :class="[
              { 'desktop-tile': $vuetify.breakpoint.lgAndUp },
              { 'tablet-tile': $vuetify.breakpoint.mdOnly },
              { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
              { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
            ]"
          >
            <v-card class="rectangle2 ml-0">
              <div>
                <p class="subtitle-2 text-center mt-3 mb-1 title-cause">{{ item.name }}</p>
              </div>
              <div class="pa-0 px-2">
                <v-flex ma-0 flex-row justify-center>
                  <v-flex xs12>
                    <v-img
                      class="sub-menu"
                      height="36"
                      width="36"
                      :src="getTruckKindImage(item.id)"
                    ></v-img>
                  </v-flex>
                  <v-flex xs12 text-center>
                    <p class="font-weight-medium my-0 title number">
                      {{ item.accident_count | numFormat }} คัน
                    </p>
                    <p class="caption mb-0">{{ item.percentage }}</p>
                  </v-flex>
                </v-flex>
              </div>
              <v-row class="ma-0 pt-6 mb-1 text-center cause-casualty">
                <v-col cols="6" class="pa-0">
                  <div class="text-center">
                    <v-img
                      contain
                      height="32"
                      :src="require('@/assets/icons/death.svg')"
                      class="ma-0 mt-2"
                    ></v-img>
                    <!-- <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
                  </div>
                  <p class="font-weight-medium subtitle-1 my-0">{{ item.dead | numFormat }}</p>
                  <p class="subtitle-2 my-0">คน</p>
                </v-col>
                <v-col cols="6" class="pa-0">
                  <div class="text-center">
                    <v-img
                      contain
                      height="32"
                      :src="require('@/assets/icons/user-injured-solid.svg')"
                      class="ma-0 mt-2"
                    ></v-img>
                  </div>
                  <p class="font-weight-medium subtitle-1 my-0">{{ item.injury | numFormat }}</p>
                  <p class="subtitle-2 my-0">คน</p>
                </v-col>
              </v-row>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Truck',
  props: {
    searchCondition: {
      type: Object
    },
    summaryDLT: {
      type: Array
    },
  },
  data: () => ({
    title: 'มูลเหตุสันนิฐาน',
    chartPieOptions: null,
    colors: ['#6F676F', '#f3a055', '#758f39', '#BDC667', '#B57B0D', '#CC98C7'],
    trailerkind: []
  }),
  created() {
    this.initData();
    this.getChartOptions();
    const scope = this;
    window.resizeTruckTimeOut = () => {
      if (window.resizeTruckChart) {
        clearTimeout(window.resizeTruckChart);
      }
      window.resizeTruckChart = setTimeout(() => {
        scope.$refs.chart.chart.reflow();
      }, 500);
    };
    window.addEventListener("resize", window.resizeTruckTimeOut);
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("resize", window.resizeTruckTimeOut);
  },
  computed: {},
  methods: {
    init() {
      this.search();
    },
    getChartOptions() {
      this.chartPieOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: 260,
          style: {
            fontFamily: 'Kanit'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          crosshair: true
        },
        yAxis: {
          title: null
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: -20
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.y:,.0f} คัน',
              distance: 0
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">จำนวนรถ</span><br/>',
          pointFormat: '{point.name}: <b>{point.y:,.0f} คัน</b>'
        },
        colors: null,
        series: {
          data: []
        }
      };
    },
    initData() {
      const initCause = {
        name: '--',
        accident: 0,
        percentage: '',
        dead: 0,
        injury: 0
      };
      this.trailerkind = [initCause, initCause, initCause];
    },
    search() {
      this.initData();
      this.searchTrailerkind();
      if (this.$refs.chart) {
        this.$refs.chart.chart.reflow();
      }
    },
    calculateOther(data, type) {
      let all_vehicle = null;
      let other_vehicle = null;
      let other_dead = null;
      let other_injury = null;
      if (this.summaryDLT) {
        const vehicle = this.summaryDLT.filter(a => a.id == 280);
        if (vehicle.length) {
          all_vehicle = vehicle[0].accident_count;
          other_vehicle = vehicle[0].accident_count;
          other_dead = vehicle[0].dead;
          other_injury = vehicle[0].injury;
          for (const i in data) {
            other_vehicle -= data[i].accident_count;
            other_dead -= data[i].dead;
            other_injury -= data[i].injury;
          }
          this[type] = data.map(item => {
            item.percentage = `${(
              (item.accident_count / all_vehicle) *
              100
            ).toFixed(2)}%`;
            return item;
          });
        }
        else {
          this[type] = data;
        }
      } else {
        this[type] = data;
      }
      this[type].sort((a, b) => b.accident_count - a.accident_count);
      this[type].push({
        name: 'อื่นๆ',
        accident_count: other_vehicle,
        percentage: all_vehicle
          ? `${((other_vehicle / all_vehicle) * 100).toFixed(2)}%`
          : '',
        dead: other_dead,
        injury: other_injury
      });
    },
    searchTrailerkind() {
      if (!(this.searchCondition && this.searchCondition.isBMTA)) {
        return;
      }
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/dlt/trailer_kind`;
      // if (this.searchCondition != null && this.searchCondition.start_date) {
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // }
      // if (this.searchCondition != null && this.searchCondition.end_date) {
      //   url += `end_date=${this.searchCondition.end_date}&`;
      // }

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            scope.trailerkind = data;
            scope.$emit('showTruck', scope.trailerkind.length > 0);
            this.calculateOther(data.slice(0, 3), 'trailerkind');
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTruckKindImage(id) {
      try {
        return require(`@/assets/dashboard_icons/dlt_kind_${id}.svg`);
      } catch (e) {
        try {
          return require(`@/assets/dashboard_icons/dlt_kind_${id}.png`);
        } catch (e) {
          return require('@/assets/icons/trailer.svg');
        }
      }
    }
  },
  watch: {
    searchCondition() {
      this.search();
    },
    trailerkind() {
      this.chartPieOptions.colors = this.colors.slice(0, this.trailerkind.length);
      const damage = [];
      this.trailerkind.forEach((vehicle, i) => {
        damage.push({ name: vehicle.name, y: vehicle.accident_count });
      });
      this.chartPieOptions.series.data = damage.filter(a => a.y > 0);
    },
    summaryDLT(val) {
      const vehicle = val.filter(a => a.id == 280);
      let all_vehicle = null;
      let other_vehicle = null;
      let other_dead = null;
      let other_injury = null;
      if (vehicle.length) {
        all_vehicle = vehicle[0].accident_count;
        other_vehicle = vehicle[0].accident_count;
        other_dead = vehicle[0].dead;
        other_injury = vehicle[0].injury;
      }
      else {
        return;
      }

      const data_type = ['trailerkind'];

      for (const x in data_type) {
        const type = data_type[x];
        if (this[type].length && this[type][0].accident_count != 0) {
          let tmp_other_vehicle = other_vehicle;
          let tmp_other_dead = other_dead;
          let tmp_other_injury = other_injury;
          for (const i in this[type]) {
            if (this[type][i].id) {
              tmp_other_vehicle -= this[type][i].accident_count;
              tmp_other_dead -= this[type][i].dead;
              tmp_other_injury -= this[type][i].injury;
            }
          }

          this[type] = this[type].map(item => {
            item.percentage = `${((item.accident_count / all_vehicle) * 100).toFixed(2)}%`;
            return item;
          });
          if (this[type].length == 1 || other_vehicle > 0) {
            this[type][this[type].length - 1] = {
              name: 'อื่นๆ',
              accident_count: tmp_other_vehicle,
              percentage: all_vehicle ? `${((tmp_other_vehicle / all_vehicle) * 100).toFixed(2)}%` : '',
              dead: tmp_other_dead,
              injury: tmp_other_injury
            };
          }
          else {
            this[type].pop();
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}

.v-tab.v-tab--active {
  background-color: #ba4438;
  color: white;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle1 {
  min-width: 110px;
  height: 210px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.rectangle2 {
  width: 100%;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.charts {
  height: 150px;
}

.charts-pie {
  height: 230px;
}

.cause-casualty {
  bottom: 0px;
  position: absolute;
  width: 100%;
}

.title-cause {
  height: 40px;
}

.injury-icon {
  height: 40px;
}

.desktop-tile {
  max-width: 240px;
}

.tablet-tile {
  max-width: 205px;
}
</style>
